export const openOfficeHour = 7
export const closeOfficeHour = 23

let nbrHours = Number(closeOfficeHour) - Number(openOfficeHour)
let hours = []
for (let i = 0; i < nbrHours; i++) {
  hours.push(openOfficeHour + i)
}

export const businessHours = hours

export let datepickerOptions = {
  type: 'day',
  week: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
  month: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
  format: 'DD/MM/YYYY',
  placeholder: '',
  // TODO move this in scss
  inputStyle: {
    'display': 'block',
    'width': '100%',
    'padding': '0.5rem 0.75rem',
    'font-size': '1rem',
    'line-height': '1.25',
    'color': '#55595c',
    'background-color': '#fff',
    'background-image': 'none',
    'background-clip': 'padding-box',
    'border': '1px solid rgba(0, 0, 0, 0.15)',
    'border-radius': '0'
  },
  color: {
    header: '#1aa9a4',
    headerText: '#fff'
  },
  buttons: {
    ok: 'OK',
    cancel: 'Retour'
  }
}



// WEBPACK FOOTER //
// ./src/options/date.js